import React from 'react';
import styled, { css } from 'styled-components';
import Svg from 'react-inlinesvg';

import ExternalLinkIconSVG from './external-link.svg';

export const ExternalLink = styled(props => <Svg alt="external link" src={ExternalLinkIconSVG} {...props} />)`
  margin: 0.3rem 0.4rem 0.3rem 0.5rem;
  min-width: 20px;
  stroke: #2a75dc;
  stroke-width: 0;
  ${props =>
    props.chooser &&
    css`
      stroke: #255af0;
      stroke-width: 0.1;
    `}
`;
